export enum PointReasonEnum {
  EARN = "earn",
  REDEEM = "redeem",
  ADJUST = "adjust",
  SIGNUP_BONUS = "signup_bonus",
}
